// Libellés des encadrés GFM (> [!NOTE], [!TIP], [!IMPORTANT], [!WARNING], [!CAUTION]),
// partagés par l'affichage (MarkdownRenderer) et la lecture à voix haute (speakable.js)
export const CALLOUT_LABELS = {
  note: 'Note',
  tip: 'Astuce',
  important: 'Important',
  warning: 'Attention',
  caution: 'Prudence',
};
